import { render } from "./reset-password.vue?vue&type=template&id=63ef1280&scoped=true"
import script from "./reset-password.vue?vue&type=script&lang=js"
export * from "./reset-password.vue?vue&type=script&lang=js"

import "./reset-password.vue?vue&type=style&index=0&id=63ef1280&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ef1280"]])

export default __exports__